import { get, getOr } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getReservationOrders = get('reservation.routes.orders');

export const getPicklists = createSelector(
  getReservationOrders,
  get('picklists')
);

export const getOrdersByPicklist = createSelector(
  getReservationOrders,
  get('ordersByPicklist')
);

export const getIsFetchingPicklists = createSelector(
  getReservationOrders,
  get('fetchingPicklists')
);

export const getIsFetchedPicklists = createSelector(
  getReservationOrders,
  get('fetchedPicklists')
);

export const getIsSavingOrders = createSelector(
  getReservationOrders,
  get('savingOrders')
);

export const getIsSavedOrders = createSelector(
  getReservationOrders,
  get('savedOrders')
);

export const getItemsAvailability = createSelector(
  getReservationOrders,
  get('itemsAvailability')
);

export const getItemAvailabilityForUniqKey = createSelector(
  (_, uniqKey) => uniqKey,
  getItemsAvailability,
  getOr(null)
);

export const getIsFetchingItemAvailability = createSelector(
  getReservationOrders,
  get('fetchingInventoryAvailability')
);

export const getItemsSumQuantityByUniqKey = createSelector(
  getReservationOrders,
  get('itemsSumQuantityByUniqKey')
);

export const getItemSumQuantityForUniqKey = createSelector(
  (_, uniqKey) => uniqKey,
  getItemsSumQuantityByUniqKey,
  getOr(0)
);

export const getItemsInitialSumQuantityByUniqKey = createSelector(
  getReservationOrders,
  get('itemsInitialSumQuantityByUniqKey')
);

export const getItemInitialSumQuantityForUniqKey = createSelector(
  (_, uniqKey) => uniqKey,
  getItemsInitialSumQuantityByUniqKey,
  getOr(0)
);

export const getHasLinkedPicklistItems = createSelector(
  getReservationOrders,
  get('hasLinkedPicklistItems')
);
